import { connect } from 'react-redux'

import ForgotPassword from './ForgotPassword'

import { resetPassword } from '../../actions/signUpActions'

const mapStateToProps = (state, props) => ({
    ...props,
    loading: state.passwordreset
})

const mapDispatchToProps = (dispatch) => ({
    resetPassword: (email, cb) => (
        dispatch(resetPassword(email, cb))
    )
})


const ForgotPasswordContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPassword)

export default ForgotPasswordContainer